import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import Adminmenu from '../../admin/adminmenu/AdminMenu';
import './SuprivisorLayout.css';
import { SHeader } from '../../Header/SHeader';
import SuprivisorMenu from '../../suprivisor/suprivisormenu/SuprivisorMenu';
import  {SuprivisorDashboard}  from '../../suprivisor/SuprivisorDashboard';
import  {SuprivisorDoctor}  from '../../suprivisor/SuprivisorDoctor';
import  {SuprivisorAssistantlist}  from '../../suprivisor/SuprivisorAssistantlist';
import  {SuprivisorLinkAssistants}  from '../../suprivisor/SuprivisorLinkAssistants';
import  {SupDoctorDetails}  from '../../suprivisor/SupDoctorDetails';
import  {SuprivisorReports}  from '../../suprivisor/SuprivisorReports';
import  {SuprivisorActivities}  from '../../suprivisor/SuprivisorActivities';
import  {SuprivisorApplications}  from '../../suprivisor/SuprivisorApplications';
import  {SupViewDoctoeReports}  from '../../suprivisor/SupViewDoctoeReports';
import  {SupViewAssReports}  from '../../suprivisor/SupViewAssReports';
import  {SupViewApprovedApplications}  from '../../suprivisor/SupViewApprovedApplications';
import  {SuprivisorProfile}  from '../../suprivisor/SuprivisorProfile';
import  {SupViewDocuments}  from '../../suprivisor/SupViewDocuments';
import  {SupAssistantDetails}  from '../../suprivisor/SupAssistantDetails';
import { Reset } from '../../reset/Reset';
import { ViewCaseDetailsSup } from '../../suprivisor/ViewCaseDetailsSup';
import { SupPatientHistory } from '../../suprivisor/SupPatientHistory';















interface SuprivisorLayout {

  children?: ReactNode;
  // Define children as a ReactNode
}
const SuprivisorLayout: React.FC<SuprivisorLayout> = ({ children }) => {


  return (
    <div className="elitecap-layout-container">
      <SHeader/>
      <div >
        <SuprivisorMenu />
]          <Routes>
             <Route path="/sdashboard" element={<SuprivisorDashboard />} />
             <Route path="/sdoctors" element={<SuprivisorDoctor />} />
             <Route path="/sassistantlist" element={<SuprivisorAssistantlist />} />
             <Route path="/slinkassistants" element={<SuprivisorLinkAssistants/>} />
             <Route path="/viewdoctors/:id" element={<SupDoctorDetails/>} />
             <Route path="/sreports" element={<SuprivisorReports/>} />
             <Route path="/sactivity" element={<SuprivisorActivities/>} />
             <Route path="/sapplications" element={<SuprivisorApplications/>} />
             <Route path="/viewdoctorreports/:id" element={<SupViewDoctoeReports/>} />
             <Route path="/viewassitantreports/:id" element={<SupViewAssReports/>} />
             <Route path="/viewapprovedapplications/:id" element={<SupViewApprovedApplications/>} />
             <Route path="/supprofile" element={<SuprivisorProfile/>} />
             <Route path="/viewdocuments" element={<SupViewDocuments/>} />
             <Route path="/viewassistantdetails/:id" element={<SupAssistantDetails/>} />
              <Route path="/supresetpassword" element={<Reset />} />
              <Route path="/viewdoctorcases/:id" element={<ViewCaseDetailsSup />} />
              <Route path="/patienthistory" element={<SupPatientHistory />} />


          </Routes>
      </div>
      { children }
      {/* <Footer /> */}
    </div>
  );
};

export default SuprivisorLayout;
